import { ValueOrArray, AnalysisResult, TesterRequest, TesterResult } from '@feedyou/utils'
import { BotDefaultLocale, NlpModel } from '@feedyou/schema'

import { getApiUrl } from '../../../apiService'
import { fetchWithAuthorization } from '../../../lib/api'

export const fetchNlpModelsTestResult = async (
  models: NlpModel[],
  defaultBotLocale: BotDefaultLocale | undefined,
  cases: TesterRequest['test']['cases'],
  authenticationBotId: string,
  onlyQueryAgainstExpectedModel: boolean
): Promise<TesterResult> => {
  return fetchWithAuthorization(`${getApiUrl()}/nlp-analyzer/test`, {
    method: 'POST',
    checkOk: true,
    headers: {
      'Content-Type': 'application/json',
      'x-user-authentication-against-bot-id': authenticationBotId
    },
    body: JSON.stringify({
      defaultBotLocale,
      models,
      test: { cases },
      onlyQueryAgainstExpectedModel
    })
  })
}

export const fetchModelAnalysis = async (
  models: ValueOrArray<NlpModel>,
  botId: string,
  defaultBotLocale?: BotDefaultLocale
): Promise<AnalysisResult> => {
  return fetchWithAuthorization(`${getApiUrl()}/nlp-analyzer/analyze`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-user-authentication-against-bot-id': botId
    },
    body: JSON.stringify({
      defaultBotLocale,
      models
    })
  }).then(res => res.json())
}
